import React from 'react';
import { MultiSelect } from 'primereact/multiselect';
import './CustomDropdown.css';

export interface CustomMultiSelectOption {
    label: string;
    value: any;
}

export interface CustomMultiSelectProps {
    label: string;
    options: CustomMultiSelectOption[];
    value: any[];
    onChange: (value: any[]) => void;
    disabled?: boolean;
    placeholder?: string;
    maxSelectedLabels?: number;
    selectedItemsLabel?: string;
}

/**
 * CustomMultiSelect wraps PrimeReact's MultiSelect
 * to provide consistent styling with CustomDropdown
 */
const CustomMultiSelect: React.FC<CustomMultiSelectProps> = ({
                                                                 label,
                                                                 options,
                                                                 value,
                                                                 onChange,
                                                                 disabled = false,
                                                                 placeholder = 'Select items',
                                                                 maxSelectedLabels = 1,
                                                                 selectedItemsLabel = '{0} items selected',
                                                             }) => {
    return (
        <div className="custom-dropdown-root">
            <label className="custom-dropdown-label">{label}</label>
            <MultiSelect
                value={value}
                onChange={(e) => onChange(e.value)}
                options={options}
                optionLabel="label"
                placeholder={placeholder}
                maxSelectedLabels={maxSelectedLabels}
                selectedItemsLabel={selectedItemsLabel}
                showSelectAll={false}
                showClear={false}
                disabled={disabled}
                display="comma"
                className="custom-multiselect"
                panelClassName="custom-multiselect-panel"
                style={{ minWidth: '200px' }}
            />
        </div>
    );
};

export default CustomMultiSelect;